import { Injectable } from '@angular/core';
import {
  delay,
  interval,
  map,
  Observable,
  takeWhile,
  timer,
} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CountdownService {
  private endTime!: number;

  start(minutes: number = 5): Observable<number> {
  const endTime = Date.now() + minutes * 60 * 1000;

  return timer(0, 1000).pipe(
    map(() => {
      const remaining = endTime - Date.now();
      return Math.max(0, Math.ceil(remaining / 1000));
    }),
    takeWhile((seconds) => seconds > 0, true)
  );
}
}
